import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { MasterDataStatusFilter, ActivationResult } from '../interfaces/masterDataStatus.interface';
import { InChargeUser, Store, StoreResponse } from '../interfaces/store.interface';
import {AuthService} from "./auth.service";

// FW-1: status omitted = ACTIVE (pickers for NEW documents); pass 'ALL' for list pages, reports and filters.
export const getStoresByInstitutionId = async (page: number = 0, size: number = 10, status?: MasterDataStatusFilter): Promise<StoreResponse> => {
    const institutionId = AuthService.getSelectedInstitution();
    const response = await axios.get(`${ENDPOINTS.STORE.LIST_BY_INSTITUTION}/${institutionId}?page=${page}&size=${size}${status ? `&status=${status}` : ''}`);
    return response.data;
};

export const getAllInstitutionStores = async (page: number = 0, size: number = 10): Promise<StoreResponse> => {
    const response = await axios.get(`${ENDPOINTS.STORE.BASE}?page=${page}&size=${size}`);
    return response.data;
};

export const createStore = async (store: Store): Promise<Store | undefined> => {
    const response = await axios.post(ENDPOINTS.STORE.BASE, store);
    return response?.data;
};

export const updateStore = async (id: string, store: Store): Promise<void> => {
    await axios.put(`${ENDPOINTS.STORE.BASE}/${id}`, store);
};

export const deleteStore = async (id: string): Promise<void> => {
    await axios.delete(ENDPOINTS.STORE.DELETE(id));
};

export const deactivateStore = async (id: string, reason?: string): Promise<ActivationResult> =>
    (await axios.post(ENDPOINTS.STORE.DEACTIVATE(id), { reason: reason?.trim() || undefined })).data;

export const activateStore = async (id: string): Promise<ActivationResult> =>
    (await axios.post(ENDPOINTS.STORE.ACTIVATE(id))).data;

export const getStoreInCharge = async (storeId: string): Promise<InChargeUser[]> =>
    (await axios.get(ENDPOINTS.STORE.IN_CHARGE(storeId))).data;

/** Replace-all: the complete list of users in charge of the store (empty clears it). */
export const setStoreInCharge = async (storeId: string, userIds: string[]): Promise<InChargeUser[]> =>
    (await axios.put(ENDPOINTS.STORE.IN_CHARGE(storeId), { userIds })).data;
